const API_BASE = process.env.REACT_APP_API_BASE || "";

function joinURL(base, path) {
  if (/^https?:\/\//i.test(path)) return path;
  const b = (base || "").replace(/\/+$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${b}${p}`;
}

/**
 * 공통 호출자
 * @param {Object} opts
 * @param {Array<{role: string, parts: Array<{text:string}>}>} opts.contents
 * @param {string} opts.api_name - 호출 출처(예: "review", "profiling")
 * @param {string} opts.userId   - 로그인 유저 id
 * @param {object} [opts.generationConfig]
 * @param {string} [opts.version]
 * @returns {Promise<any>} 서버의 JSON (파싱 완료)
 */
// 상단의 API_BASE, joinURL 유틸은 그대로 사용

export async function callAi({ contents, api_name, userId, generationConfig = null, version }) {
  const token = (typeof localStorage !== "undefined" && localStorage.getItem("token")) || "";
  const path = "/api/callAi";
    // await navigator.clipboard.writeText(contents[0].parts[0].text)
    // return;
  // 1) window.API_BASE_URL → 2) .env(REACT_APP_API_BASE) → 3) 배포 도메인 → 4) 상대경로(프록시 있을 때만)
  const candidates = [];
  candidates.push(joinURL(API_BASE, path));
  // if (API_BASE) candidates.push(joinURL(API_BASE, path));
  // candidates.push("https://ai.jayeontotal.com/api/callAi");
  // candidates.push(path);

  const payload = {
    contents,
    generationConfig,
    version,
    api_name,
    id: userId,
  };

  let lastErr = "unknown";
  for (const url of candidates) {
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      // 바디는 한 번만 읽고 안전 파싱
      const raw = await res.text();
      let data = null;
      try { data = raw ? JSON.parse(raw) : null; } catch {
        // dev 서버에서 HTML(index.html) 오면 여기로 떨어짐
        lastErr = `HTTP ${res.status} - ${raw.slice(0, 120)}`;
        continue;
      }

      if (!res.ok) {
        lastErr = data?.message || data?.error?.message || `HTTP ${res.status}`;
        continue;
      }
      return data; // 성공
    } catch (e) {
      lastErr = e?.message || "request failed";
      continue;
    }
  }

  throw new Error(lastErr);
}
